<template>
  <nav :class="{shrink}" v-on-clickaway="closeNavMobile" class="navbar navbar-default navbar-fixed-top">
    <div class="container">
      <div class="navbar-header">
        <md-button type="button" @click="toggleNavMobile" class="screen-reader mobile-hamburger">
          <span class="sr-only">{{$t('header.NAV_SR_TOGGLE_TEXT')}}</span>
          <md-icon>menu</md-icon>
        </md-button>
        <brave-link to="/"><img @click="closeNavMobile" :src="brandLogoSrc" alt="Bravenet"></brave-link>
      </div>
      <div class="vertical-divider"/>
      <div id="navbar" class="collapse navbar-collapse" :class="{open: mobileNavOpen}">
        <ul :class="currentlyActive()" class="nav navbar-nav">
          <li @click="closeNavMobile" class="homelink" style="display: none;">
            <a href="index.php"><md-button>{{$t('header.HOME')}}</md-button></a>
          </li>
          <li @click="closeNavMobile">
            <brave-link style="color: #222;" to="/webhosting" class="major-link webhosting-link">{{$t('services.WEB_HOSTING_TITLE')}}</brave-link>
          </li>
          <li @click="closeNavMobile">
            <brave-link style="color: #222;" to="/sitebuilder" class="major-link sitebuilder-link">{{$t('services.SITE_BUILDER_TITLE')}}</brave-link>
          </li>
          <li @click="closeNavMobile">
            <brave-link style="color: #222;" to="/mailinglists" class="major-link mailinglists-link">{{$t('services.MAILING_LISTS_TITLE')}}</brave-link>
          </li>
          <li @click="closeNavMobile">
            <brave-link style="color: #222;" to="/domains" class="major-link domains-link">{{$t('services.DOMAINS_TITLE')}}</brave-link>
          </li>
          <li>
            <flyout ref="services-dropdown">
              <a class="major-link webtools-link" slot="toggler">
                {{$t('services.GENERIC_TITLE')}}<span class="caret"></span>
              </a>
              <ul slot="togglable" class="dropdown" slot-scope="props">
                <template v-for="flyoutItem in flyoutItems">
                <li v-if="flyoutItem.to"
                  @click="closeAll(props.close)">
                  <md-button v-if="flyoutItem.to"
                    :to="flyoutItem.to">{{$t(`services.${flyoutItem.name}_TITLE`)}}</md-button>
                </li>
                <li v-else class="divider" role="divider">
                  <div/>
                </li>
                </template>
              </ul>
            </flyout>


          </li>
        </ul>
        <div class="navbar-right" @click="closeNavMobile">
          <md-button style="color: #fff;" :to="{path: '/login', query: navQuery()}" class="md-raised md-primary full-width">
            {{$t('header.NAV_LOGIN_TEXT')}}
          </md-button>
          <md-button style="color: #fff;" :to="{path: '/login', query: navQuery()}" class="md-raised md-primary reduced-width">
            {{$t('header.NAV_LOGIN_REDUCED_TEXT')}}
          </md-button>
          <md-button style="color: #fff;" :to="{path: '/register', query: navQuery()}" class="md-raised md-accent">
            {{$t('header.NAV_REGISTER_TEXT')}}
          </md-button>
        </div>
      </div>
    </div>
  </nav>
</template>
<script>
import {HEADER_NAV_FLYOUT_ITEMS, LEGACY_SERVICE_MAPPING} from 'app-constants'
import style from 'styles/shared-header.scss'
import flyout from 'brave-flyout/components/flyout'
import {scrollCoordinates} from 'brave-utils/window'
import {mixin as clickaway} from 'vue-clickaway'

export default {
  mixins: [clickaway],
  created() {
    this.decideShouldShrink()
    window.addEventListener('scroll', this.decideShouldShrink)
  },
  methods: {
    decideShouldShrink() {
      this.shrink = scrollCoordinates().top > 0
    },
    currentlyActive() {
      const fullPathWithoutLeadingSlash = this.$route.fullPath.slice(1); // Remove the leading /
      const modifiedPath = fullPathWithoutLeadingSlash.replace(/\//g, '-'); // Replace / with -
      const validPaths = ['', 'webhosting', 'sitebuilder', 'sitebuilder-templates', 'mailinglists', 'domains'];
      // console.log('fullPath', this.$route.fullPath);
      // console.log('fullPathWithoutLeadingSlash', fullPathWithoutLeadingSlash);
      // console.log('modifiedPath', modifiedPath);

      // Check for the specific case 'sitebuilder-templates' and return 'sitebuilder'
      if (modifiedPath === 'sitebuilder-templates') {
        return 'sitebuilder';
      }

      return validPaths.includes(modifiedPath) ? modifiedPath : '';
    },
    closeNavMobile () {
      this.mobileNavOpen = false

    },
    toggleNavMobile () {
      this.mobileNavOpen = !this.mobileNavOpen
      this.$refs['services-dropdown'].toggle()
    },
    closeAll (itemHandler) {

      itemHandler()
      this.closeNavMobile()
    },
    navQuery () {
      let view = this.$route.fullPath.substr(1)
      let legacyService = LEGACY_SERVICE_MAPPING[view]
      let query = (legacyService)
        ? {from: legacyService}
        : null
      return query
    }
  },
  data() {
    let flyoutItems = HEADER_NAV_FLYOUT_ITEMS

    return {
      flyoutItems,
      shrink: this.shrink,
      mobileNavOpen: false
    }
  },
  components: {
    'flyout': flyout
  },
  computed: {
    brandLogoSrc() {
      return require('assets/img/shared/bravenet_logo.png');
    }
  },
}
</script>


// WEBPACK FOOTER //
// apps/www.bravenet.com/src/components/shared-header.vue